import { useIsClient } from '@/hooks/ui/useIsClient';
export const CopyrightNotice = () => {
  const isClient = useIsClient();
  const year = isClient ? new Date().getFullYear() : '';
  return <p className="font-sans text-gray-700 text-xs 2xl:text-sm dark:text-gray-200" data-sentry-component="CopyrightNotice" data-sentry-source-file="CopyrightNotice.tsx">
      Copyright © {year} Music Vine Limited. <br className="md:hidden" />
      Uppbeat is a Music Vine Limited brand.
    </p>;
};